import apiClient from "./apiClient";

const API_URL = `/patient-assignments`; // Use relative path since apiClient has baseURL

export const saveAssignment = async (PatientAssignData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(API_URL, PatientAssignData);
  return response.data; 
};

export const getAssignedStaff = async (patientId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/assigned-staff/${patientId}`);
  return response.data;
};

export const getByPatientId = async (patientId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-patient/${patientId}`);
  return response.data;
};

export const getAssignmentByAdmissionId = async (admissionId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/by-admission/${admissionId}`);
  return response.data;
};


export const updateAssignment = async (id, assignment) => {
  try {
    // apiClient will automatically add organizationId via interceptor
    const response = await apiClient.put(`${API_URL}/${id}`, assignment);
    return response.data;
  } catch (error) {
    console.error("Failed to update patient assignment", error);
    throw error;
  }
};

export default {
  saveAssignment,  
  getAssignedStaff,
  getByPatientId,
  getAssignmentByAdmissionId 
}